import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {PayLinksListDto} from "../../payment-link-list/models/paylinks.model";
import {EditInformationModelsDto, InformationModelsDto} from "../models/information.models";
import {UserInfoService} from "../../../services/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class InformationDataServiceService {
  agentId: string | undefined
  userId: number | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })
  }

  loadInfo(): Observable<InformationModelsDto> {
    const url = `/agents/${this.agentId}`
    return this.apiService.httpGet<InformationModelsDto>(url)
  }

  saveInfo(data: EditInformationModelsDto): Observable<void> {
    const url = `/agents/${this.agentId}`
    return this.apiService.httpPut<void>(url, data)
  }
}
